<template>
	<Popup :show="showPopup" :use-close-button="false" @update:show="showPopup = false">
		<div class="primary-header">Important Reminder</div>
		<p class="primary-text">
			Please make sure to update your <strong>AWS usernames</strong> in the settings. In case you don't have an aws user and don't require it, Just fill your name and save it.
		</p>
		<div class="center-modal-buttons">
			<CommonButton @click="goToSettings">Update Now</CommonButton>
		</div>
	</Popup>
</template>
<script>
import { Popup, CommonButton } from 'dmui_components'
import useUserSettings from '@/components/useUserSettings'
import { watchEffect, ref } from 'vue'
import { useRouter } from 'vue-router'

export default {
	name: 'UpdateAwsUsernameReminder',

	components: {
		Popup,
		CommonButton
	},

	props: {},
	setup() {
		const { userSettings, loading } = useUserSettings()
		const showPopup = ref(false)
		const router = useRouter()
		watchEffect(() => {
			if (!loading.value && !userSettings.value?.iamUsernames?.length) {
				showPopup.value = true
			}
		})
		return {
			userSettings,
			loading,
			goToSettings: () => {
				router.push('/settings')
				showPopup.value = false
			},
			showPopup
		}
	}
}
</script>
<style scoped lang="less">
p {
	padding: 10px;
}
.center-modal-buttons {
	justify-content: center;
	display: flex;
}
</style>
